import create from 'zustand';
import { HOUSE_ID } from '@root/constant';
import { IHouse } from '@root/types/house';
import { ILoading } from '@root/types/common';
import { getQueryString } from '@root/shared';

const queryHouseId = getQueryString('houseId');

const currentHouseId = queryHouseId || localStorage.getItem(HOUSE_ID) || '';

export interface IState {
  houses: IHouse[];
  currentHouseId: string;
  updateTime: number;
  loading: ILoading;
  setHouses: (v: IHouse[]) => void;
  setCurrentHouseId: (v: string) => void;
  resetInitData: () => void;
  setLoading: (v: ILoading) => void;
}

const useHouse = create<IState>((set) => ({
  houses: [],
  currentHouseId,
  updateTime: 0,
  loading: -1,
  setLoading: (loading: ILoading) => {
    return set(() => {
      return {
        loading,
      };
    });
  },
  setHouses: (houses: IHouse[]) => {
    return set(() => {
      return {
        updateTime: new Date().getTime(),
        houses,
      };
    });
  },
  setCurrentHouseId: (id: string) => {
    return set(() => {
      window.localStorage.setItem(HOUSE_ID, id);
      return {
        currentHouseId: id,
      };
    });
  },
  resetInitData: () => {
    return set(() => {
      return {
        loading: -1,
        updateTime: 0,
        houses: [],
        currentHouseId: localStorage.getItem(HOUSE_ID) || '',
      };
    });
  },
}));

export default useHouse;
